import React, { useState } from "react";

import ForgotPasswordView from "../ui/ForgotPasswordView";
import { emailRegex } from "../../../constants/common";
import { resetPassword } from "../../../services/userService";
import { ForgotPasswordModalProps } from "../auth.types";

export default function ForgotPasswordModal({
  onClose,
}: ForgotPasswordModalProps) {
  const [email, setEmail] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onEmailChange = (text: string) => {
    setEmail(text);
    if (error) setError(null);
  };

  const handleSendResetEmail = async () => {
    setError(null);

    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }

    if (!emailRegex.test(email.trim())) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      setIsProcessing(true);
      const result = await resetPassword(email.trim());

      if (result.success) {
        setEmailSent(true);
      } else {
        setError(result.error || "Failed to send reset email");
      }
    } catch (e) {
      console.error("Failed to send reset email:", e);
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <ForgotPasswordView
      email={email}
      isProcessing={isProcessing}
      emailSent={emailSent}
      error={error}
      onEmailChange={onEmailChange}
      onSendReset={handleSendResetEmail}
      onClose={onClose}
    />
  );
}
